import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "node_child",
  "use": "node_child-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"node_child\"><path d=\"M9.5 3.35V5H17v2.5h-1V6H2v1.5H1V5h7.5V3.35c-.15-.09-.26-.21-.35-.35H4c-.28 0-.5-.22-.5-.5S3.72 2 4 2h4.15c.18-.29.48-.5.85-.5s.68.21.85.5H14c.28 0 .5.22.5.5s-.22.5-.5.5H9.85c-.09.15-.21.26-.35.35M5 13.5H3.5V12H5z\" /><path d=\"M2.51 9h12.98c.83 0 1.51.68 1.5 1.51v3.97c0 .83-.67 1.51-1.51 1.51H2.51c-.83 0-1.51-.67-1.51-1.51v-3.97C1 9.68 1.68 9 2.51 9m-.01 5.49 12.99.01v-3.99l-.01-.01H2.51z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol